module.exports = __webpack_public_path__ + "img/qilin-stage5-hungry.ecb40b4d.png";